<template>
  <div class="partner-add">
    <div @click.prevent="$emit('register-agent')"
         class="partner-add__btn">
      <BaseSvg name="ico-plus"/>
      {{ $tPartners('register_agent') }}
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
